module.exports = __webpack_public_path__ + "img/page.6c5dfa94.svg";